// extracted by mini-css-extract-plugin
export var width100 = "x_v d_v";
export var design3Pos = "x_tB d_Z";